import { defaultApi } from '@/plugins/api/defaultApi'
import { defaultV2Api } from '@/plugins/api/defaultV2Api'

export default {
  name: 'plans',
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getPlans({}) {
      const { data } = await defaultApi.getPlans()
      return data
    },
    async changePlans({}, plan) {
      const { data } = await defaultApi.postPlanChanges(plan)
      return data
    },
    async getMyPlanChoices({}) {
      const { data } = await defaultApi.getMyPlanChoices()
      return data
    },
    async getPlansRequest({}, query) {
      const { data } = await defaultV2Api.getPlansRequest(query)
      return data
    },
  },
}
